import { createContext } from 'react';
export const NewBookingContext = createContext({
    dateRange: {
        startDate: null,
        endDate: null,
    },
    startInAfternoon: false,
    endInMorning: false,
    isManagerApprovalRequired: false,
    deductFromEntitlement: false,
    updateState: null,
});
